import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const messages = defineMessages({
  customer: {
    description: 'filterOptions.customer',
    defaultMessage: 'Customer',
    id: 'aJNnHZ',
  },
});

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });
  const isSelected = !!appliedFilters.length;

  return {
    isLocked: true,
    isSelected,
    displayContent: <FormattedMessage {...messages.customer} />,
  };
};

export const Customer = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
